var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { cx, css } from 'emotion';
export var createFilterStyle = function createFilterStyle(_a) {
  var className = _a.className;
  return cx(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      outline: none;\n    "], ["\n      outline: none;\n    "]))), className);
};
var templateObject_1;